/* eslint-disable no-console */
import { populateAnalyticsMetadata, setAnalyticsMetadata, trackSignalEvent } from 'services/utils/analytics'
import { PAGE_PREFIX } from 'services/utils/constants/validations'
import {
  REGISTER_USER_REQUEST,
  REGISTER_USER_ERROR,
} from 'services/app-state/register/actions/constants'
import {
  LOGIN_USER_REQUEST,
  LOGIN_USER_ERROR,
  LOGIN_USER_SUCCESS,
} from 'services/app-state/login/actions/constants'
import {
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_ERROR,
  ADD_ADDRESS_SUCCESS,
  ADD_ADDRESS_ERROR,
  EDIT_ADDRESS_SUCCESS,
  EDIT_ADDRESS_ERROR,
  LOAD_POSTCODE_SUCCESS,
  LOAD_POSTCODE_ERROR,
  DELETE_ADDRESS_SUCCESS,
  DELETE_ADDRESS_ERROR,
  ADD_CONTACT_SUCCESS,
  ADD_CONTACT_ERROR,
  EDIT_CONTACT_SUCCESS,
  EDIT_CONTACT_ERROR,
  DELETE_CONTACT_SUCCESS,
  DELETE_CONTACT_ERROR,
  ADD_CARD_SUCCESS,
  ADD_CARD_ERROR,
  EDIT_CARD_SUCCESS,
  EDIT_CARD_ERROR,
  DELETE_CARD_SUCCESS,
  DELETE_CARD_ERROR,
  GET_PROFILE_SUCCESS,
} from 'services/app-state/profile/actions/constants'
import { LOGIN_INFO_ERROR, LOGIN_INFO_SUCCESS } from 'services/app-state/user/actions/constants'

const analyticsMiddleWare = () => next => (action) => {
  const returnValue = next(action)
  const { type, response } = action
  switch (type) {
    case REGISTER_USER_REQUEST:
      trackSignalEvent('triggerOmnitureRegisterAttempt', {
        pageName: `${PAGE_PREFIX}Register Page`,
      })
      break
    case REGISTER_USER_ERROR:
      trackSignalEvent('triggerOmnitureRegisterFailure', {
        pageName: `${PAGE_PREFIX}Register Page`,
        errorCode: response.errorCode,
      })
      break
    case LOGIN_USER_REQUEST:
      trackSignalEvent('triggerOmnitureLoginAttempt', {
        pageName: `${PAGE_PREFIX}Login Page`,
      })
      break
    case LOGIN_USER_ERROR:
      trackSignalEvent('triggerOmnitureLoginFailure', {
        pageName: `${PAGE_PREFIX}Login Page`,
        errorCode: response.errorCode,
      })
      break
    case LOGIN_USER_SUCCESS:
      trackSignalEvent('triggerOmnitureLoginSuccess', {
        pageName: `${PAGE_PREFIX}Login Page`,
      })
      break
    case UPDATE_PROFILE_SUCCESS:
      trackSignalEvent('triggerOmnitureSPEvent', {
        pageName: `${PAGE_PREFIX}Account Settings`,
        eventId: '131',
      })
      break
    case UPDATE_PROFILE_ERROR:
      trackSignalEvent('triggerOmnitureSPEvent', {
        pageName: `${PAGE_PREFIX}Account Settings`,
        eventId: '132',
        errorCode: response.errorCode,
      })
      break
    case ADD_ADDRESS_SUCCESS:
      trackSignalEvent('triggerOmnitureSPEvent', {
        pageName: `${PAGE_PREFIX}Account Settings`,
        eventId: '133',
        country: response.addresses[0].country,
      })
      break
    case ADD_ADDRESS_ERROR:
      trackSignalEvent('triggerOmnitureSPEvent', {
        pageName: `${PAGE_PREFIX}Account Settings`,
        eventId: '134',
        errorCode: response.errorCode,
      })
      break
    case EDIT_ADDRESS_SUCCESS:
      trackSignalEvent('triggerOmnitureSPEvent', {
        pageName: `${PAGE_PREFIX}Account Settings`,
        eventId: '135',
      })
      break
    case EDIT_ADDRESS_ERROR:
      trackSignalEvent('triggerOmnitureSPEvent', {
        pageName: `${PAGE_PREFIX}Account Settings`,
        eventId: '136',
        errorCode: response.errorCode,
      })
      break
    case LOAD_POSTCODE_SUCCESS:
      trackSignalEvent('triggerOmnitureSPEvent', {
        pageName: `${PAGE_PREFIX}Account Settings`,
        eventId: '137',
      })
      break
    case LOAD_POSTCODE_ERROR:
      trackSignalEvent('triggerOmnitureSPEvent', {
        pageName: `${PAGE_PREFIX}Account Settings`,
        eventId: '138',
        errorCode: response.errorCode,
      })
      break
    case DELETE_ADDRESS_SUCCESS:
      trackSignalEvent('triggerOmnitureSPEvent', {
        pageName: `${PAGE_PREFIX}Account Settings`,
        eventId: '139',
      })
      break
    case DELETE_ADDRESS_ERROR:
      trackSignalEvent('triggerOmnitureSPEvent', {
        pageName: `${PAGE_PREFIX}Account Settings`,
        eventId: '140',
        errorCode: response.errorCode,
      })
      break
    case ADD_CONTACT_SUCCESS:
      trackSignalEvent('triggerOmnitureSPEvent', {
        pageName: `${PAGE_PREFIX}Account Settings`,
        eventId: '141',
        countryCode: response.contacts[0].countryCode,
      })
      break
    case ADD_CONTACT_ERROR:
      trackSignalEvent('triggerOmnitureSPEvent', {
        pageName: `${PAGE_PREFIX}Account Settings`,
        eventId: '142',
        errorCode: response.errorCode,
      })
      break
    case EDIT_CONTACT_SUCCESS:
      trackSignalEvent('triggerOmnitureSPEvent', {
        pageName: `${PAGE_PREFIX}Account Settings`,
        eventId: '143',
      })
      break
    case EDIT_CONTACT_ERROR:
      trackSignalEvent('triggerOmnitureSPEvent', {
        pageName: `${PAGE_PREFIX}Account Settings`,
        eventId: '144',
        errorCode: response.errorCode,
      })
      break
    case DELETE_CONTACT_SUCCESS:
      trackSignalEvent('triggerOmnitureSPEvent', {
        pageName: `${PAGE_PREFIX}Account Settings`,
        eventId: '145',
      })
      break
    case DELETE_CONTACT_ERROR:
      trackSignalEvent('triggerOmnitureSPEvent', {
        pageName: `${PAGE_PREFIX}Account Settings`,
        eventId: '146',
        errorCode: response.errorCode,
      })
      break
    case ADD_CARD_SUCCESS:
      trackSignalEvent('triggerOmnitureSPEvent', {
        pageName: `${PAGE_PREFIX}Account Settings`,
        eventId: '147',
        cardBrand: response.cards[0].cardBrand,
      })
      break
    case ADD_CARD_ERROR:
      trackSignalEvent('triggerOmnitureSPEvent', {
        pageName: `${PAGE_PREFIX}Account Settings`,
        eventId: '148',
        errorCode: response.errorCode,
      })
      break
    case EDIT_CARD_SUCCESS:
      trackSignalEvent('triggerOmnitureSPEvent', {
        pageName: `${PAGE_PREFIX}Account Settings`,
        eventId: '149',
        errorCode: response.errorCode,
      })
      break
    case EDIT_CARD_ERROR:
      trackSignalEvent('triggerOmnitureSPEvent', {
        pageName: `${PAGE_PREFIX}Account Settings`,
        eventId: '150',
        errorCode: response.errorCode,
      })
      break
    case DELETE_CARD_SUCCESS:
      trackSignalEvent('triggerOmnitureSPEvent', {
        pageName: `${PAGE_PREFIX}Account Settings`,
        eventId: '151',
      })
      break
    case DELETE_CARD_ERROR:
      trackSignalEvent('triggerOmnitureSPEvent', {
        pageName: `${PAGE_PREFIX}Account Settings`,
        eventId: '152',
        errorCode: response.errorCode,
      })
      break
    case GET_PROFILE_SUCCESS:
    case LOGIN_INFO_SUCCESS:
      setAnalyticsMetadata({ isSignedIn: true })
      break
    case LOGIN_INFO_ERROR:
      setAnalyticsMetadata({ isSignedIn: false })
      break
    default:
      break
  }
  return returnValue
}

export default analyticsMiddleWare
